<div class="container container--narrow" *ngIf="isActive">
  <ng-container *ngIf="results || !loading; else loadingBlock">
    <div class="content-panel" *ngIf="queryLength >= minQueryLength">
      <air-search-results-type
        *ngFor="let type of results"
        [type]="type"
        [expanded]="type.title === expandedType"
        [collapsedLimit]="getCollapsedLimit(type.mode)"
        [hidden]="expandedType && type.title !== expandedType"
        (expand)="onExpand($event)"
        (collapse)="onCollapse($event)"
      ></air-search-results-type>
      <p *ngIf="!results || results.length < 1">
        {{ "general.search.no_results" | translate }}
      </p>
    </div>
  </ng-container>
</div>
<div class="backdrop" (click)="close()"></div>

<ng-template #loadingBlock>
  <div class="content-panel">
    <ul class="product-list grid loading">
      <ng-container *ngFor="let skeleton of [] | range: 6; let i = index">
        <li
          class="product-list__item col-3--md col-4--sm"
          [ngClass]="{ 'product-list__item--large col-6': i < 2, 'col-3': i >= 2, 'product-list__item--first': i === 2 }"
        >
          <air-skeleton-card
            [additionalClasses]="{ 'card--product': true, 'card--product--large': i < 2 }"
            [isLarge]="i < 2"
          ></air-skeleton-card>
        </li>
      </ng-container>
    </ul>
  </div>
</ng-template>
